/** @jsx jsx */

import { Fragment } from 'react';

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import NonFormaticFieldWrapper from 'app/developer-v3/components/NonFormaticFieldWrapper';
import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import Code from './Code';

type Props = {
  initValue: {};
  isRequired: boolean;
  onChange: (value?: {}) => void;
  title: string;
};

// TODO: Remove this component with StaticDropdownInputFieldZinnia when all its
// consumers are coverted to Zinnia.
function StaticDropdownInputField(props: Props) {
  const { isRequired, onChange, title, initValue } = props;

  const onBlur = nextValue => {
    if (nextValue) {
      onChange(nextValue);
      // Replace ' with " if the new value is an array of an object.
      if (nextValue.includes(']') || nextValue.includes('}')) {
        onChange(JSON.parse(nextValue.replace(/'/g, '"')));
      }
    } else {
      if (!isRequired) {
        onChange(undefined);
      }
    }
  };

  const placeholder = '["Email", "Phone", "Address"]';

  return (
    <Fragment>
      <NonFormaticFieldWrapper
        helpText={
          <Text>
            List the dropdown choices. Example: <code>{placeholder}</code>.{' '}
            <Link
              href={`${BASE_DOC_URL_VB}/build/add-fields#dropdown`}
              target="_blank"
            >
              Learn more
            </Link>
            .
          </Text>
        }
        required={isRequired}
        title={title}
      >
        <Code initValue={initValue} onBlur={onBlur} placeholder={placeholder} />
      </NonFormaticFieldWrapper>
    </Fragment>
  );
}

StaticDropdownInputField.defaultProps = {
  isRequired: true,
  title: 'Dropdown Source',
};

export default StaticDropdownInputField;
